import { render } from "./StudentDemerits.vue?vue&type=template&id=6c69f23c"
import script from "./StudentDemerits.vue?vue&type=script&lang=js"
export * from "./StudentDemerits.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__